import { CHAINS } from '../../../static/supportedChains';

export const TOP_WALLETS_PER_QUERY = 10;

export const tracerLegend = {
  nodes: [
    {
      title: 'Address Node',
      color: 'palegoldenrod',
      borderColor: 'black',
      shape: 'box',
    },
    {
      title: 'Contract Node',
      color: 'rgb(0, 210, 122)',
      borderColor: 'black',
      shape: 'box',
    },
    {
      title: 'Searched Node',
      color: '#FDCB6E',
      borderColor: 'black',
      shape: 'box',
    },
    {
      title: 'Interested Node',
      color: '#29C5FF',
      borderColor: 'black',
      shape: 'box',
    },
    {
      title: 'Address Group',
      color: ' #ff8cc8',
      borderColor: 'black',
      shape: 'box',
    },
    {
      title: "KYC'ed Address",
      color: 'yellowgreen',
      shape: 'box',
    },
    {
      title: 'Bridge Node',
      color: 'navy',
      borderColor: 'black',
      shape: 'box',
    },
    {
      title: 'Oracle Node',
      color: 'violet',
      shape: 'box',
    },
    {
      title: 'DEX',
      color: 'cornflowerblue',
      borderColor: 'black',
      shape: 'box',
    },
    {
      title: 'CEX',
      color: 'chocolate',
      borderColor: 'black',
      shape: 'box',
    },
    {
      title: 'Mixer/Mixer User',
      color: 'crimson',
      borderColor: 'black',
      shape: 'box',
    },
  ],
  edges: [
    {
      title: 'Token Flow Edge',
      color: '#B2BEC3',
      shape: 'line',
    },
    {
      title: 'In Flow Edge',
      color: '#0EAC51',
      shape: 'line',
    },
    {
      title: 'Out Flow Edge',
      color: '#C0392B',
      shape: 'line',
    },
  ],
  icons: [
    {
      title: 'Holds > $10k',
      icon: 'sack-dollar',
    },
    {
      title: 'Types of Tokens In Account',
      icon: 'coins',
    },
    {
      title: 'Risk Indicator',
    },
  ],
};
export const tracerInteractionGraphLegend = [
  {
    title: 'Address',
    color: 'palegoldenrod',
    borderColor: 'black',
    shape: 'box',
  },

  {
    title: "KYC'ed Address",
    color: 'yellowgreen',
    shape: 'box',
  },
  {
    title: 'Bridge',
    color: 'navy',
    borderColor: 'black',
    shape: 'box',
  },
  {
    title: 'Oracle',
    color: 'violet',
    shape: 'box',
  },
  {
    title: 'DEX',
    color: 'cornflowerblue',
    borderColor: 'black',
    shape: 'box',
  },
  {
    title: 'CEX',
    color: 'chocolate',
    borderColor: 'black',
    shape: 'box',
  },
  {
    title: 'Mixer',
    color: 'crimson',
    borderColor: 'black',
    shape: 'box',
  },
  { title: 'Token', color: 'orange', shape: 'box' },
];

export const ADDRESS_NODE_TYPES = {
  MIXER: 'Mixer',
  MIXER_USER: 'Mixer User',
  DEX: 'DEX',
  CEX: 'CEX',
  BRIDGE: 'Bridge',
  ORACLE: 'Oracle',
  KYC: 'KYC',
  KNOWN_ENTITY: 'Known Entity',
  BURN: 'Burn',
  TOKEN: 'Token',
  CONTRACT: 'Contract',
};

export const ADDRESS_NODE_TYPE_ICONS = {
  [ADDRESS_NODE_TYPES.MIXER]: 'arrows-rotate',
  [ADDRESS_NODE_TYPES.MIXER_USER]: 'arrows-rotate',
  [ADDRESS_NODE_TYPES.DEX]: 'arrow-right-arrow-left',
  [ADDRESS_NODE_TYPES.CEX]: 'cash-register',
  [ADDRESS_NODE_TYPES.BRIDGE]: 'bridge',
  [ADDRESS_NODE_TYPES.ORACLE]: 'tower-observation',
  [ADDRESS_NODE_TYPES.KYC]: 'person-rays',
  [ADDRESS_NODE_TYPES.KNOWN_ENTITY]: 'user',
  [ADDRESS_NODE_TYPES.BURN]: 'fire',
  [ADDRESS_NODE_TYPES.TOKEN]: 'coins',
  [ADDRESS_NODE_TYPES.CONTRACT]: 'file-contract',
};

export const ADDRESS_NODE_TYPE_COLORS = {
  [ADDRESS_NODE_TYPES.MIXER]: 'crimson',
  [ADDRESS_NODE_TYPES.MIXER_USER]: 'crimson',
  [ADDRESS_NODE_TYPES.DEX]: 'cornflowerblue',
  [ADDRESS_NODE_TYPES.CEX]: 'chocolate',
  [ADDRESS_NODE_TYPES.BRIDGE]: 'navy',
  [ADDRESS_NODE_TYPES.ORACLE]: 'violet',
  [ADDRESS_NODE_TYPES.KYC]: 'yellowgreen',
  [ADDRESS_NODE_TYPES.KNOWN_ENTITY]: 'darkgreen',
  [ADDRESS_NODE_TYPES.BURN]: 'black',
  [ADDRESS_NODE_TYPES.TOKEN]: 'orange',
  [ADDRESS_NODE_TYPES.CONTRACT]: 'rgb(0, 210, 122)',
};

export const ADDRESS_NODE_TYPE_TEXT_COLORS = {
  [ADDRESS_NODE_TYPES.MIXER]: 'white',
  [ADDRESS_NODE_TYPES.MIXER_USER]: 'white',
  [ADDRESS_NODE_TYPES.DEX]: 'white',
  [ADDRESS_NODE_TYPES.CEX]: 'white',
  [ADDRESS_NODE_TYPES.BRIDGE]: 'white',
  [ADDRESS_NODE_TYPES.ORACLE]: 'black',
  [ADDRESS_NODE_TYPES.KYC]: 'black',
  [ADDRESS_NODE_TYPES.KNOWN_ENTITY]: 'white',
  [ADDRESS_NODE_TYPES.BURN]: 'white',
  [ADDRESS_NODE_TYPES.TOKEN]: 'black',
  [ADDRESS_NODE_TYPES.CONTRACT]: 'black',
};

export const ADDRESS_NODE_TYPE_PRIORITY = [
  ADDRESS_NODE_TYPES.BURN,
  ADDRESS_NODE_TYPES.TOKEN,
  ADDRESS_NODE_TYPES.KNOWN_ENTITY,
  ADDRESS_NODE_TYPES.MIXER,
  ADDRESS_NODE_TYPES.MIXER_USER,
  ADDRESS_NODE_TYPES.CEX,
  ADDRESS_NODE_TYPES.DEX,
  ADDRESS_NODE_TYPES.BRIDGE,
  ADDRESS_NODE_TYPES.ORACLE,
  ADDRESS_NODE_TYPES.CONTRACT,
  ADDRESS_NODE_TYPES.KYC,
];
export const isHigherPriority = (prev, curr) => {
  const prevIndex = ADDRESS_NODE_TYPE_PRIORITY.indexOf(prev);
  const currIndex = ADDRESS_NODE_TYPE_PRIORITY.indexOf(curr);
  if (prevIndex === -1 && currIndex !== -1) return true;
  if (prevIndex !== -1 && currIndex === -1) return false;
  return prevIndex > currIndex;
};

export const ADDRESS_NODE_LEGEND = [
  { title: 'Mixer/Mixer User', color: 'crimson' },
  { title: ADDRESS_NODE_TYPES.DEX, color: 'cornflowerblue' },
  { title: ADDRESS_NODE_TYPES.CEX, color: 'chocolate' },
  { title: ADDRESS_NODE_TYPES.BRIDGE, color: 'navy' },
  { title: ADDRESS_NODE_TYPES.ORACLE, color: 'violet' },
  { title: ADDRESS_NODE_TYPES.KYC, color: 'yellowgreen' },
  { title: ADDRESS_NODE_TYPES.KNOWN_ENTITY, color: 'darkgreen' },
  { title: ADDRESS_NODE_TYPES.BURN, color: 'black' },
  { title: ADDRESS_NODE_TYPES.TOKEN, color: 'orange' },
  { title: ADDRESS_NODE_TYPES.CONTRACT, color: 'rgb(0, 210, 122)' },
];

export const CHAINS_WITH_NATIVE_TRANSFERS = [
  CHAINS.ETHEREUM,
  CHAINS.TRON,
  CHAINS.BASE,
];

export const MAX_FILTER_ADDRESSES = 10;

